import { useState } from "react";
import styled from "styled-components";
import DeleteIcon from "@material-ui/icons/DeleteForever";
import Radio from '@material-ui/core/Radio';
import { withStyles } from '@material-ui/core/styles';
import Input from "./text-input";

const GreenRadio = withStyles({
  root: {
    '&$checked': {
      color: '#0ab23b',
    },
  },
  checked: {},
})((props) => <Radio color="default" {...props} />);

const RadioOption = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 8px 0;
`;

const RadioGroup = ({ options, onDelete, onUpdate }) => {
  const [selectedOption, setSelectedOption] = useState("");

  const handleChange = (value) => {
    setSelectedOption(value);
  };

  return (
    <>
      {options?.map((option, index) => (
        <RadioOption key={index}>
          <GreenRadio 
            checked={selectedOption === option.id}
            onClick={() => handleChange(option.id)}
          />
          <Input
            width="330px"
            type="text"
            value={option.value}
            onChange={(e) => onUpdate(index, {...option, value: e.target.value})}
          />
          <DeleteIcon onClick={() => onDelete(index)} style={{ cursor: "pointer" }} />
        </RadioOption>
      ))}
    </>
  );
};

export default RadioGroup;
